import styled from 'styled-components';
import * as T from './types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: 0.4rem 0;
  border-radius: 6px;
  color: #000000;
  border: 0.1rem solid #a1a1a1;
  min-height: 80px;
  width: 75px;
  cursor: pointer;
  overflow: hidden;

  p {
    margin: 0;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;

interface ITitleCountProps {
  $color: string;
}
export const TitleCount = styled.p<ITitleCountProps>`
  font-size: 1.4rem;
  line-height: 1.4rem;
  font-weight: bold;
  color: ${props => props.$color};
`;
export const AreaIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 40px;
`;
export const TitleNameStatus = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  padding: 0 0.2rem;
  width: 100%;
  text-align: center;
`;

export const Ball = styled.div<T.IBallProps>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0.2rem 0 0 0;
  background-color: ${props => props.color};
`;

